import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { PedidoInterface } from "app/module/pedido-interface";
import moment from "moment";
import { ChipService } from "@core/services/chip.service";
import { ChipInterface } from "app/module/chip.interface";

@Component({
	selector: 'app-listar-chip',
	templateUrl: './listar-chip.component.html',
	styleUrls: ['./listar-chip.component.scss']
})
export class ListarChipComponent implements OnInit {
	constructor(private chipService: ChipService) {
		this._unsubscribeAll = new Subject();
	}

	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	starting = false;
	contentHeader: object;
	basicSelectedOption: number = 10;
	ColumnMode = ColumnMode;
	rows: Array<ChipInterface> | any = [];
	temp: Array<ChipInterface> | any = [];
	selectedStatus: any;
	dateOptions = {
		altInput: true,
		mode: 'single',
		altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
		defaultDate: moment(new Date).format('YYYY-MM-DD'),
		altFormat: "d/m/Y",
	};

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		this.starting = true;
		this.contentHeader = {
			headerTitle: "Planos",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Plano",
						isLink: false,
					},
				],
			},
		};

		this.chipService.findAll().subscribe(
			(res) => {
				(this.rows = res), (this.temp = res), (this.tempData = this.rows);
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d[param] != null) return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
		
	}

	confirmDeleteAlert(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja excluir o item?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
			}
		});
	}
}
